import appInfo from '../app-info';
import { apiHelper, call_post_api } from './api_helper';
export async function select_all() {
    return call_post_api(appInfo.api_url + '/lop/select_all');
};
export async function select_by_id(id) {
    return call_post_api(appInfo.api_url + '/lop/select_by_id', id);
};
export async function insert(data) {
    return call_post_api(appInfo.api_url + '/lop/insert', data);
}

export async function update(data) {
    return call_post_api(appInfo.api_url + '/lop/update', data);
}

export async function remove(id) {
    return call_post_api(appInfo.api_url + '/lop/delete', id);
}

export async function tu_dong_phan_lop(data) {
    return call_post_api(appInfo.api_url + '/lop/automaticclassifier', data);
}
export async function huy_phan_lop(data) {
    return call_post_api(appInfo.api_url + '/lop/xoaphanlop', data);
}


export const LOP_API_ENDPOIT = 'lop';

export const lopApi = {
    SelectAll: () => apiHelper.get(LOP_API_ENDPOIT),
    Insert: (data) => apiHelper.post(LOP_API_ENDPOIT, data),
    Update: (data) => apiHelper.put(LOP_API_ENDPOIT, data),
    Detail: (id) => apiHelper.get(`${LOP_API_ENDPOIT}/${id}`),
    Delete: (id) => apiHelper.delete(`${LOP_API_ENDPOIT}/${id}`),
    SelectTreeView: (nam_hoc) => apiHelper.get(`${LOP_API_ENDPOIT}/${nam_hoc}/tree-view`),
    SelectTreeViewByCoSo: (nam_hoc, dm_coso_id) => apiHelper.get(`${LOP_API_ENDPOIT}/nam-hoc/${nam_hoc}/co-so/${dm_coso_id}/tree-view`),
    SelectHocSinh: (data) => apiHelper.post(`${LOP_API_ENDPOIT}/hoc-sinh`, data),
    SelectByNamHoc: (nam_hoc) => apiHelper.get(`${LOP_API_ENDPOIT}/nam-hoc/${nam_hoc}`),
    InsertMultipleStudentUpgrade: (data) => apiHelper.post('lop/hoc-sinh/insert-multiple', data),
    ChangeStudentClass: (data) => apiHelper.put('lop/hoc-sinh/update', data),
    RemoveStudent: (data) => apiHelper.put('lop/hoc-sinh/remove', data),
    ImportPhanLop: (data) => apiHelper.put('lop/hoc-sinh/import', data),

}